import mixpanel from "mixpanel-browser";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { routeList } from "../../App";
import { lang } from "../../assets/languages/en.language";
import TraitInput from "../../components/form/Trait.input";
import { usePwaViewportWidth } from "../../hooks/useScreenWidth";
import api from "../../services/api";
import { getVpFontSize } from "../../services/utils";
import { useUserStore } from "../../store/useUserStore";
import { PurpleButton } from "../../styles/Button.style";
import { MainContainer, RootContainer } from "../../styles/Container.style";
import { BigTitle, Paragraph } from "../../styles/Text";
import { Gap } from "../../styles/Utils";

export default function HighlightsPage() {
  const {
    profile: { traits },
    setTraits,
  } = useUserStore();
  const [selectedTraits, setSelectedTraits] = useState<string[]>(traits);

  const navigate = useNavigate();
  const viewportWidth = usePwaViewportWidth();

  const handleSubmission = async () => {
    try {
      await api.addTraits({ traits: selectedTraits });
      mixpanel.track("Update Highlights");
      setTraits(selectedTraits);
      navigate(routeList.profile);
    } catch (err) {
      console.log("Error adding traits", err);
      alert("Error adding traits");
    }
  };

  const formValid = selectedTraits.length == 3;

  return (
    <RootContainer>
      <BigTitle $fontSize={getVpFontSize(viewportWidth, 13)}>{lang.highlightPage.title}</BigTitle>
      <Gap $height={1} />
      <MainContainer>
        <Paragraph>{lang.highlightPage.message}</Paragraph>
        <Gap $height={1} />
        <TraitInput selectedTraits={selectedTraits} setSelectedTraits={setSelectedTraits} />
      </MainContainer>
      <Gap $height={1.5} />
      <PurpleButton type="submit" disabled={!formValid} onClick={handleSubmission}>
        <span>{lang.buttons.continue}</span>
      </PurpleButton>
    </RootContainer>
  );
}
